import { AIReviewsSummary, Section } from '@seek/libs-shared';
import { useTranslations } from '@vocab/react';
import { Card } from 'braid-design-system';
import type { SalariesTabModel } from '../../../pages/salaries/salariesTabModel';
import translations from './.vocab/index';

interface CompanyReviewAISummarySectionProps {
  model: Pick<SalariesTabModel, 'companyReviewsAISummary' | 'companyName'>;
}

export const CompanyReviewAISummarySection = ({
  model,
}: CompanyReviewAISummarySectionProps) => {
  const { companyReviewsAISummary, companyName } = model;
  const { t } = useTranslations(translations);
  return (
    <Section
      mode={'view'}
      heading={t('Working at companyName', { companyName })}
      padding={'none'}
    >
      <Card>
        <AIReviewsSummary
          companyName={companyName}
          companyReviewsAISummary={companyReviewsAISummary}
          shouldDisplayHeading={false}
        />
      </Card>
    </Section>
  );
};
